module.exports = __webpack_public_path__ + "img/app_korat_2.da509931.jpg";